import { useTranslation } from 'react-i18next';
import { FormField, TextInput } from '@vipso/shared';

export interface VendorFormValues {
  name: string;
  phone: string;
  email: string;
}

export const EMPTY_VENDOR_FORM: VendorFormValues = {
  name: '',
  phone: '',
  email: '',
};

export function vendorFormValues(vendor: {
  name: string;
  phone?: string | null;
  email?: string | null;
}): VendorFormValues {
  return {
    name: vendor.name,
    phone: vendor.phone || '',
    email: vendor.email || '',
  };
}

export function VendorForm({
  value,
  onChange,
}: {
  value: VendorFormValues;
  onChange: (next: VendorFormValues) => void;
}) {
  const { t } = useTranslation();
  const set = <K extends keyof VendorFormValues>(
    key: K,
    next: VendorFormValues[K],
  ) => onChange({ ...value, [key]: next });

  return (
    <>
      <FormField label={t('common.name')} required>
        <TextInput
          value={value.name}
          onChange={(e) => set('name', e.currentTarget.value)}
        />
      </FormField>
      <FormField label={t('common.phone')}>
        <TextInput
          value={value.phone}
          onChange={(e) => set('phone', e.currentTarget.value)}
        />
      </FormField>
      <FormField label={t('common.email')}>
        <TextInput
          value={value.email}
          onChange={(e) => set('email', e.currentTarget.value)}
        />
      </FormField>
    </>
  );
}
